
import { computed, defineComponent, PropType, reactive } from 'vue'

// components
import ButtonDropdown from '@/common/components/UI/ButtonDropdown/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// realisation
import { users } from '@/core/realisations/users.realisation'

// types
import { CourierT } from '@/core/types/couriers.types'

// composable
import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    components: { ButtonDropdown, TheButton },
    props: {
        courier: {
            type: Object as PropType<CourierT>,
            required: true,
        },
    },
    emits: ['update', 'delete'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()

        const state = reactive({
            is_user_session_loading: false,
        })

        const createUserSession = async () => {
            try {
                state.is_user_session_loading = true
                const response = await users.getUserToken(props.courier.user_id)

                const url = process.env.VUE_APP_IMPERSONATE_COURIER_URL!
                window.open(`${url}?impersonate_token=${response.access_token}`, '_blank')?.focus()
            } catch (error) {
                console.error(error)
            } finally {
                state.is_user_session_loading = false
            }
        }

        const emitUpdate = () => {
            emit('update', props.courier)
        }

        const emitDelete = () => {
            emit('delete', props.courier)
        }

        const isCanDelete = computed(() => {
            if (havePermissions(['couriers-destroy', 'all-root-permission'])) return true
            return false
        })

        return {
            state,
            createUserSession,
            emitUpdate,
            emitDelete,
            isCanDelete,
        }
    },
})
